import React from "react";
import { useLocation, useHistory, useParams } from "react-router-dom";

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let history = useHistory();
    let params = useParams();
    return <Component {...props} location={location} history={history} routeParams={params} />;
  }

  return ComponentWithRouterProp;
}

export default withRouter;
